import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
import path from "path";
import { isExternal } from "@/utils/validate";
import store from "@/store";
import Item from "./Item.vue";
import AppLink from "./Link.vue";
import FixiOSBug from "./FixiOSBug";
export default {
  name: "SidebarItem",
  components: {
    Item,
    AppLink
  },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    return {
      permissions: []
    };
  },
  computed: {
    // 待办统计（响应式），驱动菜单红点
    pendingStat() {
      return this.$store.getters.pendingStat || {};
    }
  },
  created() {
    this.permissions = store.getters.permissions;
  },
  methods: {
    // 单个路由 meta.dotKey 对应的统计值是否 > 0
    dotByKey(meta) {
      const key = meta && meta.dotKey;
      return key ? (this.pendingStat[key] || 0) > 0 : false;
    },
    // 父级菜单：递归检查可见子项是否存在待办红点
    submenuHasDot(item) {
      if (!item || !item.children) {
        return this.dotByKey(item && item.meta);
      }
      return item.children.some(child => {
        if (child.hidden) {
          return false;
        }
        if (this.dotByKey(child.meta)) {
          return true;
        }
        return this.submenuHasDot(child);
      });
    },
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        }
        // Temp set(will be used if only has one showing child)
        this.onlyOneChild = item;
        return true;
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = {
          ...parent,
          path: "",
          noShowingChildren: true
        };
        return true;
      }
      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    }
  }
};